import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { GetGeoData } from 'models/geodata'; // Importing GetGeoData function from models/geodata

/**
 * GeoView class extends JetView to create a geographical data visualization.
 */
export default class GeoView extends JetView {
    /**
     * Configures the layout of the GeoView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for internationalization
        return {
            type: 'clean', // Type of the view
            gravity: 2, // Gravity for layout positioning
            rows: [
                // Array of rows in the layout
                {
                    template: _('Origin of clients'), // Header template with localized text
                    type: 'header', // Type of the row
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    type: 'form', // Type of the row
                    rows: [
                        // Array of rows within the form
                        {
                            view: 'geochart', // View type for geographical chart
                            localId: 'chart', // Local ID for referencing the chart
                            borderless: true, // Removes border from the chart
                            key: 'AIzaSyAi0oVNVO-e603aUY8SILdD4v9bVBkmiTg', // API key for the chart
                            chart: {
                                // Configuration for the chart
                                colorAxis: {
                                    // Color settings for the chart's color axis
                                    colors: [
                                        // Array of colors for the color axis
                                        '#8664C6',
                                        '#8664C6',
                                        '#8664C6',
                                        '#1CA1C1',
                                        '#FFC107',
                                        '#FFC107',
                                        '#F8643F',
                                        '#F8643F',
                                    ],
                                },
                                datalessRegionColor: '#D9D8D7', // Color for regions without data
                                legend: 'none', // Hides the legend
                            },
                            columns: [
                                // Column definitions for the chart data
                                { type: 'string', label: 'country' }, // Country column
                                { type: 'number', label: 'money' }, // Money column
                            ],
                            tooltip: `${_('Clients')}: #clients#<br/>${_('Income')}: #money#`, // Tooltip format for chart
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the GeoView by parsing geographical data into the chart.
     */
    init() {
        this.$$('chart').parse(GetGeoData()); // Parses data from GetGeoData into the chart
    }
}

// FILE DOCUMENTED
